export const enCommonTranslations = {
  common: {
    filterUnavailable: "This filter can't be applied.",
    learnMore: 'Learn More',
    yes: 'Yes',
    no: 'No',
    cancel: 'Cancel',
    apply: 'Apply',
    reset: 'Reset',
    approve: 'Approve',
    dismiss: 'Dismiss',
    confirm: 'Confirm',
    save: 'Save',
    delete: 'Delete',
    edit: 'Edit',
    eventValueAssignAccessibleName: '{{attribute}}: assign',
    eventValueNoOtherValues: 'No other values',
    eventValueNotAnOption: 'Not one of the current options',
    close: 'Close',
    back: 'Back',
    next: 'Next',
    submit: 'Submit',
  },
  dependentBreak: {
    heading: 'Can’t {{verb}} “{{name}}”',
    verb: {
      hide: 'hide',
      delete: 'delete',
      rename: 'rename',
      unpublish: 'unpublish',
      edit: 'edit',
      move: 'move',
    },
    noun: {
      dashboard: 'dashboard',
      column: 'column',
      scheduledReport: 'scheduled report',
      email: 'email',
      card: 'card',
      filter: 'filter',
    },
    single: 'The “{{name}}” {{noun}} uses it.',
    many_one: '{{count}} thing uses it, including:',
    many_other: '{{count}} things use it, including:',
    item: 'the “{{name}}” {{noun}}',
    more_one: 'and {{count}} more.',
    more_other: 'and {{count}} more.',
    hidden_one: 'and {{count}} more you don’t have access to.',
    hidden_other: 'and {{count}} more you don’t have access to.',
    hiddenOnly_one: 'It’s used in {{count}} place you don’t have access to.',
    hiddenOnly_other: 'It’s used in {{count}} places you don’t have access to.',
    fixWithSetupChat: 'Fix with setup chat',
    contactOneStep: 'Contact OneStep to change it.',
  },
};
